/* eslint-disable unicorn/consistent-destructuring */
/* eslint-disable unicorn/prefer-module */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import React, { useCallback, useEffect, useState, useMemo } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import toast from "react-hot-toast";
import { Loader, BuildingDetailsModal } from "..";
import { useAuthContext } from "../../context/auth";
import {
  getOportunidades,
  getIntermediarios,
  getEdificiosOperativos,
  getClientes,
  getOportunidadesBTL,
  getContratos,
  getUsers,
  log,
  calcularPorcentajeComisionIntermediario,
  obtenerNombreIntermediario,
  calcularImporteNetoIntermediario,
  getConvertedImporte,
  getRateForOpp,
  calcularComisionEdificiosTotal,
  calculateComission,
} from "../../utils";
import { getApxMonto } from "../../utils/apx";
import { cargarCobroPorVenta } from "../../utils/cobro/cargarCobroVentas";
import { cargarSnapshotComision, cargarSnapshotPctCongelado } from "../../utils/comisionSnapshot";
import { cargarCostosIntermediacion, getTakeLocal } from "../../utils/costosIntermediacion";
import { getImporteFacturable } from "../../utils/getImporteFacturable";
import { getLocale } from "../../utils/getLocale";
import { useExchangeRates } from "../../utils/useExchangeRates";
import { Header } from "../Header";
import styles from "./VentasFacturasEjecutivo.module.scss";
import "./stylesVentasFacturasEjecutivo.scss";

export const VentasFacturasEjecutivo = () => {
  const [todasOportunidades, setTodasOportunidades] = useState([]);
  const [oportunidadesFiltradas, setOportunidadesFiltradas] = useState([]);
  const [intermediarios, setIntermediarios] = useState([]);
  const [filtroNumeroFactura, setFiltroNumeroFactura] = useState("");
  const [filtroCliente, setFiltroCliente] = useState("");
  const [filtroCobrada, setFiltroCobrada] = useState("");
  const [numerosFacturaUnicos, setNumerosFacturaUnicos] = useState([]);
  const [clientesUnicos, setClientesUnicos] = useState([]);
  const [filtroAno, setFiltroAno] = useState(new Date().getFullYear().toString());
  const [filtroMeses, setFiltroMeses] = useState([]);
  const [filtroIntermediario, setFiltroIntermediario] = useState("");
  const [intermediariosUnicos, setIntermediariosUnicos] = useState([]);
  const [edificios, setEdificios] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filtroEjecutivo, setFiltroEjecutivo] = useState("");
  const [ejecutivos, setEjecutivos] = useState({});
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [clientes, setClientes] = useState([]);
  // Snapshot de comisión (Paso 5): denominador congelado por venta/mes. Fallback a pantallastotales.
  const [snapMap, setSnapMap] = useState(null);
  // A3 (7.22): % de intermediación congelado (foto). Vacío/null → todo en vivo.
  const [pctMap, setPctMap] = useState(null);
  const [costosMap, setCostosMap] = useState(null);

  const { pais, id, rol } = useAuthContext();
  const { dolarFallback, getDolarValue, loaded: ratesLoaded } = useExchangeRates(pais);
  // FASE 6: take programático en moneda local (0 si la venta no tiene costos cargados).
  const getTake = useCallback(
    (opp) => getTakeLocal(opp, "sales", opp.id, costosMap, getDolarValue, dolarFallback[pais]),
    [costosMap, getDolarValue, dolarFallback, pais]
  );
  const getRate = useCallback(
    (opp) => (ratesLoaded ? getRateForOpp(opp, getDolarValue, dolarFallback[pais]) : 1),
    [ratesLoaded, getDolarValue, dolarFallback, pais]
  );

  const monedaStr = { Chile: "$", Perú: "S/", Uruguay: "$" }[pais] || "$";
  const decimalesNum = { Chile: 0, Perú: 2, Uruguay: 0 }[pais] || 0;

  const mesEnLetras = useCallback((mes) => {
    const mesesEnLetras = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    return mesesEnLetras[parseInt(mes, 10) - 1] || "";
  }, []);

  const esGerenciaOAdministracion = ["gerencia", "administrativo", "inversor"].includes(rol.toLowerCase());

  // Oportunidades filtradas por todos los criterios EXCEPTO el filtro de ejecutivo.
  // Se usa para derivar el dropdown de ejecutivos sin que éste se autofiltre.
  const oportunidadesPreEjecutivo = useMemo(() => {
    const yearSeleccionado = filtroAno ? parseInt(filtroAno, 10) : null;
    return todasOportunidades.filter((op) => {
      const fechaFactura = op.facturafecha ? new Date(op.facturafecha) : null;
      const mesFactura = fechaFactura ? (fechaFactura.getMonth() + 1).toString().padStart(2, "0") : null;
      const mesFiltrado =
        filtroMeses.length > 0 ? filtroMeses.includes(mesFactura) || filtroMeses.includes(op.mes) : true;
      const intermediarioFiltrado = filtroIntermediario ? op.intermediarioId == filtroIntermediario : true;
      const perteneceAlAno = yearSeleccionado
        ? fechaFactura
          ? fechaFactura.getFullYear() === yearSeleccionado
          : parseInt(op.ano, 10) === yearSeleccionado
        : true;
      return (
        mesFiltrado &&
        intermediarioFiltrado &&
        (filtroNumeroFactura ? op.facturanumero === filtroNumeroFactura : true) &&
        (filtroCliente ? op.cliente === filtroCliente : true) &&
        (filtroCobrada ? (filtroCobrada === "Sí" ? op.facturafechacobro : !op.facturafechacobro) : true) &&
        perteneceAlAno &&
        op.estatus === "100%" &&
        !op.eliminada
      );
    });
  }, [
    todasOportunidades,
    filtroAno,
    filtroMeses,
    filtroIntermediario,
    filtroNumeroFactura,
    filtroCliente,
    filtroCobrada,
  ]);

  // Incluye ejecutivos del desglose de comisión (ej: Nicolás cobra en todas las ventas Chile 2026+)
  const ejecutivosConComision = useMemo(() => {
    if (Object.keys(clientes).length === 0 || Object.keys(edificios).length === 0) {
      return [...new Set(oportunidadesPreEjecutivo.map((o) => o.ejecutivo))]
        .filter((e) => e && e !== "null" && e !== "")
        .sort();
    }
    const allIds = new Set();
    oportunidadesPreEjecutivo.forEach((op) => {
      if (op.ejecutivo && op.ejecutivo !== "null" && op.ejecutivo !== "") {
        allIds.add(op.ejecutivo);
      }
      const r = getRate(op);
      const loc = op.moneda_dolar ? { ...op, importe: (parseFloat(op.importe) || 0) * r, moneda_dolar: false } : op;
      const desglose = calculateComission.getSalesCommissionBreakdown(
        loc,
        clientes,
        intermediarios,
        edificios,
        undefined,
        snapMap,
        getTake(op),
        pctMap
      );
      desglose.forEach((d) => {
        if (d.ejecutivo) allIds.add(String(d.ejecutivo));
      });
    });
    return [...allIds].sort();
  }, [oportunidadesPreEjecutivo, clientes, intermediarios, edificios, getRate, snapMap, pctMap, getTake]);

  useEffect(() => {
    if (!ratesLoaded) return;
    const fetchData = async () => {
      try {
        // Fetch PAUTA opportunities, intermediaries, buildings, clients, and snapshot denominators
        const [allOportunidades, allIntermediarios, edificiosData, allClientes, allContratos, snap, costos, pct] =
          await Promise.all([
            getOportunidades({ pais }),
            getIntermediarios({ pais }),
            getEdificiosOperativos({ pais }),
            getClientes({ pais }),
            getContratos({ pais }),
            cargarSnapshotComision(pais).catch(() => null), // si falla → null → fallback a pantallastotales
            cargarCostosIntermediacion(pais).catch(() => null), // FASE 6: take programático por venta
            cargarSnapshotPctCongelado(pais).catch(() => null), // A3 (7.22): % congelado; vacío → vivo
          ]);
        setSnapMap(snap);
        setCostosMap(costos);
        setPctMap(pct);

        // Convert to maps for efficient lookups
        const clientesMap = allClientes.reduce((acc, c) => {
          if (acc[c.id]) log.warn(`Duplicate client ID: ${c.id}`);
          acc[c.id] = c;
          return acc;
        }, {});

        const intermediariosMap = allIntermediarios.reduce((acc, i) => {
          if (acc[i.id]) log.warn(`Duplicate intermediary ID: ${i.id}`);
          acc[i.id] = i;
          return acc;
        }, {});

        const edificiosMap = edificiosData.reduce((acc, e) => {
          if (acc[e.id]) log.warn(`Duplicate edificio ID: ${e.id}`);
          acc[e.id] = e;
          return acc;
        }, {});

        // Filter PAUTA opportunities based on user role and clean invalid ejecutivo
        const userOportunidades = esGerenciaOAdministracion
          ? allOportunidades
          : allOportunidades.filter((oportunidad) => oportunidad.ejecutivo === id.toString());
        // Validate and clean ejecutivo field
        const invalidOportunidades = userOportunidades.filter(
          (op) => !op.ejecutivo || op.ejecutivo === "null" || op.ejecutivo === ""
        );
        if (invalidOportunidades.length > 0) {
          log.warn(
            `Found ${invalidOportunidades.length} opportunities with missing or invalid ejecutivo fields`,
            invalidOportunidades
          );
        }
        const cleanedOportunidades = userOportunidades.map((op) => ({
          ...op,
          ejecutivo: op.ejecutivo && op.ejecutivo !== "null" && op.ejecutivo !== "" ? op.ejecutivo : null,
        }));
        // Mark PAUTA opportunities as non-BTL
        const pautaOportunidades = cleanedOportunidades.map((op) => ({ ...op, isBTL: false }));
        // Determine unique years from PAUTA opportunities for fetching BTL sales
        const years = [
          ...new Set(
            pautaOportunidades
              .map((op) => {
                if (op.facturafecha) return new Date(op.facturafecha).getFullYear();
                if (op.ano) return parseInt(op.ano, 10);
                return new Date().getFullYear();
              })
              .filter((year) => year)
          ),
        ];
        // Fetch BTL sales for each year
        const btlPromises = years.map((year) =>
          getOportunidadesBTL({ pais, ano: year }).catch((error) => {
            log.error(`Error fetching BTL opportunities for year ${year}:`, error);
            return [];
          })
        );
        const btlResults = await Promise.all(btlPromises);
        const allBtlSales = btlResults.flat();
        // Normalize and deduplicate BTL sales with cleaned ejecutivo
        const uniqueBtlSales = new Map();
        const userBtlSales = (
          esGerenciaOAdministracion ? allBtlSales : allBtlSales.filter((sale) => sale.ejecutivo === id.toString())
        )
          .filter((sale) => {
            if (!sale.id) {
              return false;
            }
            if (uniqueBtlSales.has(sale.id)) {
              return false;
            }
            uniqueBtlSales.set(sale.id, true);
            return true;
          })
          .map((sale) => {
            const cliente = allClientes.find((c) => c.id === sale.client_id); // Temporary use of array
            const clienteNombre = cliente ? cliente.nombre : "SIN CLIENTE";
            const buildings = sale.buildings
              ? typeof sale.buildings === "string"
                ? JSON.parse(sale.buildings)
                : sale.buildings
              : [];
            const edificiosParticipantes = buildings.map((b) => b.id).join(",") || "";
            const totalImporte = buildings.reduce((sum, building) => sum + (building.importe || 0), 0);
            const intermediarioNombre = sale.intermediario || "SIN INTERMEDIARIO";
            const intermediarioObj = allIntermediarios.find((i) => i.nombre === sale.intermediario);
            const intermediarioId = intermediarioObj ? intermediarioObj.id : null;
            const comisionIntermediario = sale.comision || 0;
            return {
              ...sale,
              cliente: clienteNombre,
              importe: totalImporte,
              edificiosparticipantes: edificiosParticipantes,
              estatus: "100%",
              isBTL: true,
              intermediario: intermediarioNombre,
              intermediarioId, // Added for special cases
              comision: comisionIntermediario,
              ejecutivo: sale.ejecutivo && sale.ejecutivo !== "null" && sale.ejecutivo !== "" ? sale.ejecutivo : null,
            };
          });
        // Map CONTRATOS: explode meses JSONB into individual rows
        const mappedContratos = (allContratos || [])
          .filter((c) => c.estatus === "100%" && !c.eliminada)
          .flatMap((c) =>
            (c.meses || []).map((mesObj, idx) => {
              const [mesStr, anoStr] = (mesObj.mes || "01-2026").split("-");

              // Campos por tipo de pantalla (para comisión edificios)
              let pAsc = mesObj.pantallas_ascensores || "";
              let pEsp = mesObj.pantallas_espera || "";
              let pCir = mesObj.pantallas_circulacion || "";
              let pCow = mesObj.pantallas_cowork || "";

              // Backward compat: si hay edificios asignados pero sin datos por tipo, auto-calcular
              if (mesObj.edificios_ids && !pAsc && !pEsp && !pCir && !pCow) {
                const ids = mesObj.edificios_ids
                  .split(",")
                  .map((s) => Number(s.trim()))
                  .filter(Boolean);
                const asc = [],
                  esp = [],
                  cir = [],
                  cow = [];
                ids.forEach((eid) => {
                  const e = edificiosMap[eid];
                  if (!e) return;
                  if ((Number(e.pantallas) || 0) > 0) asc.push(eid);
                  if ((Number(e.espera) || 0) > 0) esp.push(eid);
                  if ((Number(e.totems) || 0) > 0) cir.push(eid);
                  if ((Number(e.cowork) || 0) > 0) cow.push(eid);
                });
                pAsc = asc.join(",");
                pEsp = esp.join(",");
                pCir = cir.join(",");
                pCow = cow.join(",");
              }

              return {
                id: `contrato-${c.id}-${idx}`,
                contrato_id: c.id,
                mes_index: idx, // conector con la vinculación SII (venta_ref_index) para getCobroReal
                type: "contrato",
                client_id: c.client_id,
                cliente: clientesMap[c.client_id]?.nombre || c.cliente || "Desconocido",
                ejecutivo: c.ejecutivo ? String(c.ejecutivo) : null,
                pais: c.pais,
                importe: mesObj.importe || 0,
                moneda_dolar: c.moneda_dolar || false,
                isBTL: false,
                facturafecha: mesObj.facturafecha,
                facturanumero: mesObj.facturanumero,
                facturafechacobro: mesObj.facturafechacobro,
                mes: mesStr,
                ano: anoStr,
                mes_cierre: c.mes_cierre,
                estatus: "100%",
                eliminada: false,
                edificiosparticipantes: mesObj.edificios_ids || "",
                pantallastotales: mesObj.pantallas_totales || 0,
                pantallas_ascensores: pAsc,
                pantallas_espera: pEsp,
                pantallas_circulacion: pCir,
                pantallas_cowork: pCow,
                campana: c.campana,
                // Acuerdos a nivel contrato (aplican a todos sus meses): APX + override de volumen.
                // Necesarios para que el cálculo (getApxMonto) y el % display compongan el APX en
                // filas de contrato, igual que en pauta. Gating por apx_id. Espejo de b631720.
                apx_id: c.apx_id,
                descuento_acuerdo_pct: c.descuento_acuerdo_pct,
              };
            })
          );
        const userContratos = esGerenciaOAdministracion
          ? mappedContratos
          : mappedContratos.filter((c) => c.ejecutivo === id.toString());

        // Merge PAUTA, BTL and CONTRATOS, sort by date
        const combinedOportunidades = [...pautaOportunidades, ...userBtlSales, ...userContratos]
          .map((op) => {
            let intermediarioId = null;
            if (op.client_id) {
              const clienteAsociado = clientesMap[op.client_id];
              if (clienteAsociado && clienteAsociado.agencia) {
                intermediarioId = parseInt(clienteAsociado.agencia, 10);
              }
            }
            if (op.isBTL && op.intermediarioId) {
              intermediarioId = op.intermediarioId;
            }
            return {
              ...op,
              intermediarioId,
            };
          })
          .sort((a, b) => {
            // Facturados primero, pendientes después
            const aFacturado = !!a.facturafecha;
            const bFacturado = !!b.facturafecha;
            if (aFacturado !== bFacturado) return aFacturado ? -1 : 1;
            if (aFacturado) {
              // Ambos facturados: por fecha factura desc
              return new Date(b.facturafecha) - new Date(a.facturafecha);
            }
            // Ambos pendientes: por mes/año desc
            const mesA = new Date(a.ano, parseInt(a.mes, 10) - 1);
            const mesB = new Date(b.ano, parseInt(b.mes, 10) - 1);
            return mesB - mesA;
          });

        // Recaudada por la VERDAD de cobro real (getCobroReal, 4 caminos), NO el facturafechacobro
        // crudo de la venta (que el cobro SII nunca puebla → mismo Bug B que tenía edificios). Overlay
        // por venta sobre sales y sales_contratos (por mes, contrato_id+mes_index). BTL fuera de alcance.
        const cobroPorVenta = await cargarCobroPorVenta(pais).catch(() => new Map());
        for (const op of combinedOportunidades) {
          if (op.isBTL || op.type === "BTL") continue;
          const key = op.type === "contrato" ? `sales_contratos:${op.contrato_id}:${op.mes_index}` : `sales:${op.id}:`;
          const cobro = cobroPorVenta.get(key);
          op.facturafechacobro = cobro?.cobrada ? cobro.fecha || op.facturafecha : null;
        }

        setTodasOportunidades(combinedOportunidades);
        setIntermediarios(intermediariosMap); // Use map
        setEdificios(edificiosMap); // Use map
        setClientes(clientesMap); // Use map
        const intermediariosUnicos = [...new Set(Object.values(intermediariosMap).map((i) => i.nombre))].sort();
        setIntermediariosUnicos(intermediariosUnicos);
        // Traemos TODOS los usuarios (incluidos deshabilitados) para el map de labels
        // del dropdown: hay oportunidades históricas con ejecutivos ya finiquitados.
        // getUsers pagina con .range() (evita el cap max-rows=2000 de PostgREST); incluye
        // deshabilitados para resolver labels de ejecutivos finiquitados.
        const allUsers = await getUsers({ includeDisabled: true });
        if (!allUsers || allUsers.length === 0) {
          log.error("Failed to fetch users or empty user data returned", usersError);
          setEjecutivos({});
          return;
        }
        const ejecutivosMap = allUsers.reduce((acc, user) => {
          acc[user.id] = user.nombre;
          return acc;
        }, {});
        setEjecutivos(ejecutivosMap);
      } catch (error) {
        log.error("Error fetching data:", error);
        toast.error("Hubo un error al cargar los datos.");
      } finally {
        setIsLoading(false);
      }
    };
    setIsLoading(true);
    fetchData();
  }, [pais, id, rol, esGerenciaOAdministracion, ratesLoaded]);

  useEffect(() => {
    const filtrarOportunidades = () => {
      const yearSeleccionado = filtroAno ? parseInt(filtroAno, 10) : null;

      const filtradas = todasOportunidades
        .filter((oportunidad) => {
          const fechaFactura = oportunidad.facturafecha ? new Date(oportunidad.facturafecha) : null;
          const mesFactura = fechaFactura ? (fechaFactura.getMonth() + 1).toString().padStart(2, "0") : null;

          const mesFiltrado =
            filtroMeses.length > 0 ? filtroMeses.includes(mesFactura) || filtroMeses.includes(oportunidad.mes) : true;

          const intermediarioFiltrado = filtroIntermediario ? oportunidad.intermediarioId == filtroIntermediario : true;

          // Si tiene facturafecha, solo esa fecha determina el año.
          // Si no tiene facturafecha (pendiente), usa ano de la oportunidad.
          const perteneceAlAno = yearSeleccionado
            ? fechaFactura
              ? fechaFactura.getFullYear() === yearSeleccionado
              : parseInt(oportunidad.ano, 10) === yearSeleccionado
            : true;

          // Filtros básicos
          const basico =
            mesFiltrado &&
            intermediarioFiltrado &&
            (filtroNumeroFactura ? oportunidad.facturanumero === filtroNumeroFactura : true) &&
            (filtroCliente ? oportunidad.cliente === filtroCliente : true) &&
            (filtroCobrada
              ? filtroCobrada === "Sí"
                ? oportunidad.facturafechacobro
                : !oportunidad.facturafechacobro
              : true) &&
            perteneceAlAno &&
            oportunidad.estatus === "100%" &&
            !oportunidad.eliminada;
          if (!basico) return false;

          // Filtro ejecutivo: busca en el desglose de comisión (no solo ejecutivo asignado)
          if (filtroEjecutivo) {
            const r = getRate(oportunidad);
            const loc = oportunidad.moneda_dolar
              ? { ...oportunidad, importe: (parseFloat(oportunidad.importe) || 0) * r, moneda_dolar: false }
              : oportunidad;
            const desglose = calculateComission.getSalesCommissionBreakdown(
              loc,
              clientes,
              intermediarios,
              edificios,
              undefined,
              snapMap,
              getTake(oportunidad),
              pctMap
            );
            return (
              desglose.some((d) => String(d.ejecutivo) === filtroEjecutivo) || oportunidad.ejecutivo === filtroEjecutivo
            );
          }
          return true;
        })
        .map((oportunidad) => {
          const rate = getRate(oportunidad);
          // Convertir a moneda local para todos los cálculos de comisión
          const local = oportunidad.moneda_dolar
            ? { ...oportunidad, importe: (parseFloat(oportunidad.importe) || 0) * rate, moneda_dolar: false }
            : oportunidad;
          const intermediarioNombre = obtenerNombreIntermediario(
            oportunidad,
            Object.values(clientes),
            Object.values(intermediarios),
            pais
          );
          const comisionIntermediarioPorcentaje = calcularPorcentajeComisionIntermediario(
            oportunidad,
            Object.values(clientes),
            Object.values(intermediarios),
            pais,
            pctMap
          );
          // Facturable (7.22): base del neto y del bruto mostrado. Sin descuento → = importe.
          const importeBruto = getImporteFacturable(local);
          const takeLocal = getTake(oportunidad);
          const apxLocal = getApxMonto(local, intermediarios, pctMap);
          const agencyCommission = calculateComission.calculateAgencyCommission(
            local,
            clientes,
            intermediarios,
            undefined,
            pctMap
          );
          const netoDespuesAgencias = calcularImporteNetoIntermediario(
            local,
            Object.values(clientes),
            Object.values(intermediarios),
            pais,
            pctMap
          );
          const comisionEdificio = calcularComisionEdificiosTotal(
            local,
            edificios,
            netoDespuesAgencias,
            snapMap,
            takeLocal,
            apxLocal
          );
          const netoParaComercial = importeBruto - agencyCommission - takeLocal - apxLocal - comisionEdificio;
          const comisionVendedor = calculateComission.calculateSalesCommission(
            local,
            clientes,
            intermediarios,
            edificios,
            undefined,
            snapMap,
            takeLocal,
            pctMap
          );
          const desgloseComision = calculateComission.getSalesCommissionBreakdown(
            local,
            clientes,
            intermediarios,
            edificios,
            undefined,
            snapMap,
            takeLocal,
            pctMap
          );
          const neto = Math.max(0, netoParaComercial);

          let intermediarioId = null;
          if (oportunidad.client_id) {
            const clienteAsociado = clientes[oportunidad.client_id];
            if (clienteAsociado && clienteAsociado.agencia) {
              intermediarioId = parseInt(clienteAsociado.agencia, 10);
            }
          }
          if (oportunidad.isBTL && oportunidad.intermediarioId) {
            intermediarioId = oportunidad.intermediarioId;
          }

          // APX: el % y el monto de intermediación mostrados componen agencia% + apx% (10+9=19) SI
          // apx_id; sin apx_id → solo agencia% (idéntico a hoy). Surface el costo del 9% en la línea
          // de intermediación. Display-side, no toca el motor de %. Ratio independiente de moneda.
          const apxPct = importeBruto > 0 ? (apxLocal / importeBruto) * 100 : 0;
          return {
            ...oportunidad,
            intermediario: intermediarioNombre,
            comision: comisionIntermediarioPorcentaje + apxPct,
            intermediarioId,
            comisionedificio: comisionEdificio,
            comisionvendedor: comisionVendedor,
            desgloseComision,
            neto: neto,
            edificiosparticipantes: String(oportunidad.edificiosparticipantes),
          };
        });

      setOportunidadesFiltradas(filtradas);

      const numerosFactura = [...new Set(filtradas.map((o) => o.facturanumero))]
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
      setNumerosFacturaUnicos(numerosFactura);

      const clientesUnicos = [...new Set(filtradas.map((o) => o.cliente))].filter(Boolean).sort();
      setClientesUnicos(clientesUnicos);
    };

    if (todasOportunidades.length > 0 && Object.keys(edificios).length > 0 && Object.keys(clientes).length > 0) {
      filtrarOportunidades();
    }
  }, [
    filtroMeses,
    filtroNumeroFactura,
    filtroCliente,
    filtroCobrada,
    filtroAno,
    filtroIntermediario,
    todasOportunidades,
    intermediarios,
    edificios,
    clientes,
    filtroEjecutivo,
    getRate,
    snapMap,
    pctMap,
  ]);

  // Comisión liquidable: comisión de ventas YA COBRADAS (facturafechacobro),
  // cruzando todos los meses. Respeta filtroAno y filtroEjecutivo; ignora
  // filtroMeses y filtroCobrada (por eso itera todasOportunidades, no las filtradas).
  const totalComisionLiquidable = useMemo(() => {
    const yearSeleccionado = filtroAno ? parseInt(filtroAno, 10) : null;
    return todasOportunidades.reduce((total, oportunidad) => {
      if (oportunidad.estatus !== "100%" || oportunidad.eliminada || !oportunidad.facturafechacobro) {
        return total;
      }
      if (yearSeleccionado) {
        const fechaFactura = oportunidad.facturafecha ? new Date(oportunidad.facturafecha) : null;
        const perteneceAlAno = fechaFactura
          ? fechaFactura.getFullYear() === yearSeleccionado
          : parseInt(oportunidad.ano, 10) === yearSeleccionado;
        if (!perteneceAlAno) return total;
      }
      const rate = getRate(oportunidad);
      const local = oportunidad.moneda_dolar
        ? { ...oportunidad, importe: (parseFloat(oportunidad.importe) || 0) * rate, moneda_dolar: false }
        : oportunidad;
      const takeLocal = getTake(oportunidad);
      if (filtroEjecutivo) {
        const desglose = calculateComission.getSalesCommissionBreakdown(
          local,
          clientes,
          intermediarios,
          edificios,
          undefined,
          snapMap,
          takeLocal,
          pctMap
        );
        const participa =
          desglose.some((d) => String(d.ejecutivo) === filtroEjecutivo) || oportunidad.ejecutivo === filtroEjecutivo;
        if (!participa) return total;
        const porcion = desglose
          .filter((d) => String(d.ejecutivo) === filtroEjecutivo)
          .reduce((s, d) => s + (d.comision || 0), 0);
        return total + porcion;
      }
      return (
        total +
        calculateComission.calculateSalesCommission(
          local,
          clientes,
          intermediarios,
          edificios,
          undefined,
          snapMap,
          takeLocal,
          pctMap
        )
      );
    }, 0);
  }, [
    todasOportunidades,
    filtroAno,
    filtroEjecutivo,
    clientes,
    intermediarios,
    edificios,
    getRate,
    snapMap,
    pctMap,
    getTake,
  ]);

  const calcularTotales = () => {
    let totalVenta = 0;
    let totalComisionIntermediario = 0;
    let totalComisionEdificio = 0;
    let totalComisionVendedor = 0;
    let totalNeto = 0;
    oportunidadesFiltradas.forEach((oportunidad) => {
      // Importe convertido a moneda local (mismo criterio que la columna IMPORTE de
      // la tabla); evita mezclar USD crudo con CLP/PEN en las cards BRUTO y AGENCIAS.
      // Facturable (7.22): coherente con la fila y con la card NETO. Sin descuento → = importe.
      const importe = getConvertedImporte(
        { ...oportunidad, importe: getImporteFacturable(oportunidad) },
        getRate(oportunidad)
      );
      totalVenta += importe;
      // Comisión de Agencias: Usa el % precalculado y aplica al importe
      totalComisionIntermediario += (oportunidad.comision / 100) * importe || 0;
      // Comisión de Edificios: Suma el valor precalculado
      totalComisionEdificio += oportunidad.comisionedificio || 0;
      // Comisión Comercial: con filtro de ejecutivo, sumar solo la porción de ese
      // ejecutivo del desglose; sin filtro, sumar la comisión comercial total de la venta.
      if (filtroEjecutivo) {
        const porcionEjecutivo = (oportunidad.desgloseComision || [])
          .filter((d) => String(d.ejecutivo) === filtroEjecutivo)
          .reduce((s, d) => s + (d.comision || 0), 0);
        totalComisionVendedor += porcionEjecutivo;
      } else {
        totalComisionVendedor += oportunidad.comisionvendedor || 0;
      }
      // Neto: Suma el valor precalculado
      totalNeto += oportunidad.neto || 0;
    });
    return {
      totalVenta,
      totalComisionIntermediario,
      totalComisionEdificio,
      totalNeto,
      totalComisionVendedor,
    };
  };

  const totales = calcularTotales();

  const fecha = { day: "2-digit", month: "2-digit", year: "numeric" };
  if (todasOportunidades.length === 0 || Object.keys(intermediarios).length === 0) return <Loader />;
  const renderMesOptions = () =>
    ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"].map((mes, index) => {
      const mesValue = index < 9 ? `0${index + 1}` : `${index + 1}`;
      return (
        <div key={index} className="form-check-facturas" style={{ marginBottom: "5px" }}>
          <input
            className={styles.checkboxInput}
            type="checkbox"
            id={`mes-${index}`}
            value={mesValue}
            checked={filtroMeses.includes(mesValue)}
            onChange={(e) => handleMesChange(e.target.value)}
          />
          <label className={styles.checkboxLabel} htmlFor={`mes-${index}`}>
            {mes}
          </label>
        </div>
      );
    });
  const handleMesChange = (mes) => {
    setFiltroMeses((prev) => (prev.includes(mes) ? prev.filter((item) => item !== mes) : [...prev, mes]));
  };

  if (isLoading) return <Loader />;

  const fv = (val) =>
    val != null ? val.toLocaleString(getLocale(pais), { maximumFractionDigits: 0, minimumFractionDigits: 0 }) : "0";

  return (
    <div className="mis-facturas">
      <Header expandChildren>
        <div className={styles.filtersContainer}>
          <div className={styles.filterRow}>
            <div>
              <select
                className={`form-control ${filtroNumeroFactura ? styles.activeFilter : ""}`}
                value={filtroNumeroFactura}
                onChange={(e) => setFiltroNumeroFactura(e.target.value)}
              >
                <option value="">N. Factura</option>
                {numerosFacturaUnicos.map((numero) => (
                  <option key={numero} value={numero}>
                    {numero}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <select
                className={`form-control ${filtroCliente ? styles.activeFilter : ""}`}
                value={filtroCliente}
                onChange={(e) => setFiltroCliente(e.target.value)}
              >
                <option value="">Cliente</option>
                {clientesUnicos.map((cliente) => (
                  <option key={cliente} value={cliente}>
                    {cliente}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <Dropdown>
                <Dropdown.Toggle
                  variant="white border"
                  id="dropdown-basic"
                  className={`form-control text-start ${filtroMeses.length > 0 ? styles.activeFilter : ""}`}
                >
                  {filtroMeses.length > 0 ? filtroMeses.map((mes) => mesEnLetras(mes)).join(", ") : "Mes/meses"}
                </Dropdown.Toggle>
                <Dropdown.Menu>{renderMesOptions()}</Dropdown.Menu>
              </Dropdown>
            </div>
            <div>
              <select
                className={`form-control ${filtroIntermediario ? styles.activeFilter : ""}`}
                value={filtroIntermediario}
                onChange={(e) => setFiltroIntermediario(e.target.value)}
              >
                <option value="">Intermediario</option>
                {intermediariosUnicos.map((nombre) => {
                  const inter = Object.values(intermediarios).find((i) => i.nombre === nombre);
                  const interId = inter ? inter.id : null;
                  return (
                    <option key={interId || nombre} value={interId}>
                      {nombre}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className={styles.filterRowCentered}>
            <div>
              <select
                className={`form-control ${filtroAno ? styles.activeFilter : ""}`}
                value={filtroAno}
                onChange={(e) => setFiltroAno(e.target.value)}
              >
                <option value="">HTD</option>
                {["2024", "2025", "2026"].map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <select
                className={`form-control ${filtroCobrada ? styles.activeFilter : ""}`}
                value={filtroCobrada}
                onChange={(e) => setFiltroCobrada(e.target.value)}
              >
                <option value="">Cobrada</option>
                <option value="Sí">Sí</option>
                <option value="No">No</option>
              </select>
            </div>
            <div>
              <select
                className={`form-control ${filtroEjecutivo ? styles.activeFilter : ""}`}
                value={filtroEjecutivo}
                onChange={(e) => setFiltroEjecutivo(e.target.value)}
              >
                <option value="">Ejecutivo</option>
                {ejecutivosConComision.map((ejecutivoId) => (
                  <option key={ejecutivoId} value={ejecutivoId}>
                    {ejecutivos[ejecutivoId] || ejecutivoId}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </Header>

      <div className={styles.cardsContainer}>
        {[
          { label: "BRUTO", value: totales.totalVenta },
          { label: "COMISIÓN AGENCIAS", value: totales.totalComisionIntermediario },
          { label: "COMISIÓN EDIFICIOS", value: totales.totalComisionEdificio },
          { label: "NETO", value: totales.totalNeto },
          { label: "COMISIÓN COMERCIAL", value: totales.totalComisionVendedor },
          { label: "COMISIÓN LIQUIDABLE", value: totalComisionLiquidable },
        ].map(({ label, value }) => (
          <div key={label} className={styles.card}>
            <div className={styles.cardHeader}>{label}</div>
            <div className={styles.cardBody}>
              <p className={styles.cardTitle}>{`${monedaStr} ${fv(value)}`}</p>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.tableContainer}>
        <div className="table-responsive">
          <table className="table table-hover table-sm ventas-facturas-table">
            <colgroup>
              <col className="ventas-facturas-tipo-col" />
              <col className="ventas-facturas-cliente-col" />
              <col className="ventas-facturas-numero-col" />
              <col className="ventas-facturas-fecha-col" />
              <col className="ventas-facturas-importe-col" />
              <col className="ventas-facturas-agencia-col" />
              <col className="ventas-facturas-porcentaje-inter-col" />
              <col className="ventas-facturas-importe-inter-col" />
              <col className="ventas-facturas-participantes-col" />
              <col className="ventas-facturas-porcentaje-edificios-col" />
              <col className="ventas-facturas-importe-edificios-col" />
              <col className="ventas-facturas-neto-col" />
              <col className="ventas-facturas-comision-comercial-col" />
              <col className="ventas-facturas-ejecutivo-col" />
            </colgroup>
            <thead className="text-center align-middle">
              <tr>
                <th rowSpan="2" className="ventas-facturas-tipo-col">
                  TIPO
                </th>
                <th rowSpan="2" className="ventas-facturas-cliente-col">
                  CLIENTE
                </th>
                <th colSpan="3" className="ventas-facturas-factura-col">
                  FACTURA
                </th>
                <th colSpan="3" className="ventas-facturas-intermediario-col">
                  INTERMEDIARIO
                </th>
                <th colSpan="3" className="ventas-facturas-comision-edificios-col">
                  COMISIÓN EDIFICIOS
                </th>
                <th rowSpan="2" className="ventas-facturas-neto-col">
                  NETO
                </th>
                <th rowSpan="2" className="ventas-facturas-comision-comercial-col">
                  COMISIÓN COMERCIAL
                </th>
                <th rowSpan="2" className="ventas-facturas-ejecutivo-col">
                  EJECUTIVO
                </th>
              </tr>
              <tr>
                <th className="ventas-facturas-numero-col">NÚMERO</th>
                <th className="ventas-facturas-fecha-col">FECHA</th>
                <th className="ventas-facturas-importe-col">IMPORTE</th>
                <th className="ventas-facturas-agencia-col">AGENCIA</th>
                <th className="ventas-facturas-porcentaje-inter-col">%</th>
                <th className="ventas-facturas-importe-inter-col">IMPORTE</th>
                <th className="ventas-facturas-participantes-col">DETALLE</th>
                <th className="ventas-facturas-porcentaje-edificios-col">%</th>
                <th className="ventas-facturas-importe-edificios-col">IMPORTE</th>
              </tr>
            </thead>
            <tbody>
              {oportunidadesFiltradas.length === 0 ? (
                <tr>
                  <td colSpan="14" className="text-center">
                    No hay facturas ni ventas según los filtros seleccionados :(
                  </td>
                </tr>
              ) : (
                oportunidadesFiltradas.map((oportunidad) => {
                  const {
                    cliente,
                    comision,
                    comisionedificio,
                    comisionvendedor,
                    desgloseComision,
                    facturafecha,
                    facturanumero,
                    id: opId,
                    intermediario,
                    neto,
                    isBTL,
                    ejecutivo,
                  } = oportunidad;
                  const sinEdificios = oportunidad.type === "contrato" && !oportunidad.edificiosparticipantes;
                  const estiloAprox = sinEdificios ? { fontStyle: "italic", fontSize: "0.75rem", color: "#999" } : {};

                  return (
                    <tr key={opId}>
                      <td className="bg-success text-white ventas-facturas-tipo-col">{isBTL ? "BTL" : "PAUTA"}</td>
                      <td className="ventas-facturas-cliente-col text-start">{cliente}</td>
                      <td className="ventas-facturas-numero-col">{facturanumero || "Pendiente"}</td>
                      <td className="ventas-facturas-fecha-col">
                        {facturafecha ? new Date(facturafecha).toLocaleDateString("es-ES", fecha) : "Pendiente"}
                      </td>
                      <td className="text-end ventas-facturas-importe-col">
                        {`${monedaStr} ${
                          getConvertedImporte(
                            { ...oportunidad, importe: getImporteFacturable(oportunidad) },
                            getRate(oportunidad)
                          ).toLocaleString(getLocale(pais), {
                            maximumFractionDigits: decimalesNum,
                            minimumFractionDigits: decimalesNum,
                          }) || "0"
                        }`}
                      </td>
                      <td className="ventas-facturas-agencia-col text-start">{intermediario}</td>
                      <td className="text-center ventas-facturas-porcentaje-inter-col">
                        {intermediario === "DIRECTO" || intermediario === "SIN INTERMEDIARIO"
                          ? "-"
                          : `${comision.toFixed(0)}%`}
                      </td>
                      <td className="text-end ventas-facturas-importe-inter-col">
                        {intermediario === "DIRECTO" || intermediario === "SIN INTERMEDIARIO"
                          ? "-"
                          : `${monedaStr} ${(
                            getConvertedImporte(
                              { ...oportunidad, importe: getImporteFacturable(oportunidad) },
                              getRate(oportunidad)
                            ) *
                              (comision / 100)
                          ).toLocaleString(getLocale(pais), {
                            maximumFractionDigits: decimalesNum,
                            minimumFractionDigits: decimalesNum,
                          })}`}
                      </td>
                      {oportunidad.type === "contrato" && !oportunidad.edificiosparticipantes ? (
                        <>
                          <td className="ventas-facturas-participantes-col text-center" colSpan="3">
                            <span style={{ fontStyle: "italic", fontSize: "0.75rem", color: "#999" }}>
                              Edificios sin vincular
                            </span>
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="ventas-facturas-participantes-col">
                            <span
                              style={{
                                cursor: "pointer",
                                color: "blue",
                                textDecoration: "underline",
                                display: "block",
                              }}
                              onClick={() => setSelectedOpportunity(oportunidad)}
                            >
                              Detalle
                            </span>
                          </td>
                          <td className="text-center ventas-facturas-porcentaje-edificios-col">
                            {(() => {
                              const oppRate = getRate(oportunidad);
                              const loc = oportunidad.moneda_dolar
                                ? {
                                    ...oportunidad,
                                    importe: (parseFloat(oportunidad.importe) || 0) * oppRate,
                                    moneda_dolar: false,
                                  }
                                : oportunidad;
                              const importeBruto = parseFloat(loc.importe) || 0;
                              const agencyCommission = calculateComission.calculateAgencyCommission(
                                loc,
                                clientes,
                                intermediarios,
                                undefined,
                                pctMap
                              );
                              const netoPostAgencia = importeBruto - agencyCommission;
                              const porcentaje =
                                netoPostAgencia > 0 ? (Math.round(comisionedificio) / netoPostAgencia) * 100 : 0;
                              return `${porcentaje.toLocaleString(getLocale(pais), {
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1,
                              })}%`;
                            })()}
                          </td>
                          <td className="text-end ventas-facturas-importe-edificios-col">
                            {`${monedaStr} ${Math.round(comisionedificio || 0).toLocaleString(getLocale(pais), {
                              maximumFractionDigits: decimalesNum,
                              minimumFractionDigits: decimalesNum,
                            })}`}
                          </td>
                        </>
                      )}
                      <td className="text-end ventas-facturas-neto-col" style={estiloAprox}>
                        {`${monedaStr} ${neto.toLocaleString(getLocale(pais), {
                          maximumFractionDigits: decimalesNum,
                          minimumFractionDigits: decimalesNum,
                        })}`}
                      </td>
                      <td className="text-end ventas-facturas-comision-comercial-col" style={estiloAprox}>
                        {desgloseComision && desgloseComision.length > 0
                          ? desgloseComision.map((item, idx) => (
                            <div key={idx} className="desglose-row">
                              {`${monedaStr} ${Math.round(item.comision).toLocaleString(getLocale(pais), {
                                maximumFractionDigits: decimalesNum,
                                minimumFractionDigits: decimalesNum,
                              })}`}
                            </div>
                          ))
                          : `${monedaStr} ${(comisionvendedor || 0).toLocaleString(getLocale(pais), {
                            maximumFractionDigits: decimalesNum,
                            minimumFractionDigits: decimalesNum,
                          })}`}
                      </td>
                      <td className="ventas-facturas-ejecutivo-col text-center">
                        {desgloseComision && desgloseComision.length > 0
                          ? desgloseComision.map((item, idx) => (
                            <div key={idx} className="desglose-row">
                              {ejecutivos[item.ejecutivo] || `ID ${item.ejecutivo}`}
                            </div>
                          ))
                          : ejecutivo && ejecutivos[ejecutivo]
                            ? ejecutivos[ejecutivo]
                            : ejecutivo || "No asignado"}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
      {selectedOpportunity && (
        <BuildingDetailsModal
          opportunity={selectedOpportunity}
          buildings={edificios}
          clientes={clientes}
          intermediarios={intermediarios}
          pais={pais}
          snapMap={snapMap}
          pctMap={pctMap}
          takeLocal={getTake(selectedOpportunity)}
          getRate={getRate}
          moneda={monedaStr}
          localString={getLocale(pais)}
          decimales={decimalesNum}
          onClose={() => setSelectedOpportunity(null)}
        />
      )}
    </div>
  );
};
